import { DomSanitizer } from '@angular/platform-browser';
import { AdvisingAbnormalTableHeaderUpdateRequest } from './interface/advising-abnormal-table-header-update-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { AdvisingAbnormalMailRequest } from './interface/advising-abnormal-mail-request';
import { AdvisingAbnormalCreateAbnormalItemRequest } from './interface/advising-abnormal-create-abnormal-item-request';
import { LaasOption } from './../../../../core/models/laas-option';
import { AdvisingAbnormalTableAbnormalItemGetRequest } from './interface/advising-abnormal-table-abnormal-item-get-request';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { AdvisingAbnormalTableHeaderGetRequest } from './interface/advising-abnormal-table-header-get-request';
import { AdvisingAbnormalService } from './../../services/advising-abnormal.service';
import { AdvisingAbnormalTableAbnormalItemSaveRequest } from './interface/advising-abnormal-table-abnormal-item-save-request';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ChangeDetectorRef, Component, computed, Injector, Input, OnInit, QueryList, Signal, signal, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { PageInfo } from 'src/app/core/models/page-info';
import { deepCopy, getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AdvisingAbnormalTableAbnormalItemData } from './interface/advising-abnormal-table-abnormal-item-data';
import { AdvisingAbnormalTableDetailData } from './interface/advising-abnormal-table-detail-data';
import { AdvisingAbnormalTableHeaderData } from './interface/advising-abnormal-table-header-data';
import { Checkbox } from 'primeng/checkbox';
import { throwError, Subscription } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { AdvisingAbnormalTableHeaderUpdateBean } from './interface/advising-abnormal-table-header-update-bean';
import { Chips } from 'primeng/chips';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { AdvisingAbnormalTableDetailGetRequest } from './interface/advising-abnormal-table-detail-get-request';
import { Dialog } from 'primeng/dialog';
import { AdvisingAbnormalDialogAbnormalItemFileUpdateRequest } from './interface/advising-abnormal-dialog-abnormal-item-file-update-request';
import { AdvisingAbnormalItemFileBase64Bean } from './interface/advising-abnormal-item-file-base64-bean';
import { AdvisingAbnormalDialogItemFile } from './interface/advising-abnormal-dialog-abnormal-item-file';
import { AdvisingAbnormalItemFileResponse } from './interface/advising-abnormal-item-file-response';
import { ActivatedRoute, Params } from '@angular/router';
import { AdvisingServiceService } from '../../services/advising-service.service';
import { AdHeaderInfoResponse } from 'src/app/core/models/transport-operation/ad-header-info-response';
import { UserPreferenceConstants } from '../../../../core/constants/user-preference-constants.constant';
import { AdvisingAbnormalItemFilesRequest } from './interface/advising-abnormal-item-file-request';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';

export enum DisplayMode {
  Desktop,
  Mobile
}

export enum AbnormalItemFileDialogMode {
  Edit,
  Download
}

@Component({
  selector: 'laas-advising-abnormal',
  templateUrl: './advising-abnormal.component.html',
  styleUrls: ['./advising-abnormal.component.scss']
})

export class AdvisingAbnormalComponent extends SessionBaseComponent implements OnInit {

  currentLang: string = this.laasSetting.language;
  //#endregion Abnormal Item File Dialog Variable

  //#region Constructor

  constructor(
    private injector: Injector,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
    private advisingAbnormalService: AdvisingAbnormalService,
    private route: ActivatedRoute,
    private advisingServiceService: AdvisingServiceService,
    private dropdownOptionsService: DropdownOptionsService,
  ) {
    super(injector)
    let windowResizeEventListener = this.onWindowResize.bind(this)
    window.addEventListener('resize', windowResizeEventListener)
    if (window.innerWidth <= this.MOBILE_MODE_WINDOW_WIDTH) {
      this.changeToMobileMode();
    }
    this.searchFormGroup = this.formBuilder.group({
      orderQueryScope: [OrderQueryScopeEnum.personal, Validators.required],
      facility: null,
      vendorNumber: null,
      hawbNo: null,
      adNo: null,
      invoiceNo: null,
      notified: null,
      replied: null,
      pcsrAndCsrList: []
    });

    this.newAbnormalItemDialogFormGroup = this.formBuilder.group({
      abnormalCaseCnt: null,
      waitingReference: null,
      waitingReferenceDesc: null
    })

    this.initAllOption();
    this.initAllTable();

    this.filePermission = true;

  }

  //#region Table Column Filter
  @Input() get selectedColumnsOfRelatedDetailTable(): DateTableColumn[] {
    return this.selectedColumnGroupOfRelatedDetailTable;
  }

  set selectedColumnsOfRelatedDetailTable(cols: DateTableColumn[]) {
    this.selectedColumnGroupOfRelatedDetailTable = this.columnGroupOfRelatedDetailTable.filter(col => cols.includes(col))
  }

  readonly ERROR_CODE_CATEGORY = "AdvisingAbnormal"

  //#region Permission Variable
  readonly advisingAbnormalSendNotification = PermissionConstants.AdvisingAbnormalSendNotification;
  readonly advisingAbnormalReplyNotification = PermissionConstants.AdvisingAbnormalReplyNotification;
  readonly advisingAbnormalEdit = PermissionConstants.AdvisingAbnormalEdit
  readonly advisingAbnormalUpload = PermissionConstants.AdvisingAbnormalUpload
  readonly viewPermissionCode = PermissionConstants.ViewAdvisingAbnormal;
  //#endregion Permission Variable

  //#region RWD Variable

  displayMode: DisplayMode = DisplayMode.Desktop; // desktop or mobile
  readonly MOBILE_MODE_WINDOW_WIDTH = 640; // the breakpoint of responsive table of current version is 640px
  readonly DISPLAY_MODE_ENUM = DisplayMode;
  mobileTabPanelActiveIndex: number = 0;

  //#endregion RWD Variable

  //#region Option Variable
  protected readonly OrderQueryScopeEnum = OrderQueryScopeEnum;
  facilityOptions: FacilityOptions[] = [];
  docStatusOptions = signal<LaasOption[]>([]);
  vendorNumberOptions: LaasOption[] = [];
  emailMarkOptions = signal<LaasOption[]>([]);
  waitingReferenceOptionsOfHeaderTable: LaasOption[] = [];
  waitingReferenceOptionsOfAbnormalItemTable: LaasOption[] = [];
  pcsrAndCsrOptions: LaasOption[] = [];

  //#endregion Option Variable

  //#region Search Form Variable

  isSearchFormOpen: boolean = true;
  searchFormGroup: FormGroup;

  //#endregion Search Form Variable

  //#region Header Table Variable

  readonly headerPreferenceKey: string = UserPreferenceConstants.AdvisingAbnormalTableHeaderData;
  // The Header table for Header table part
  @ViewChild('headerTable') headerTable!: Table;
  // Checkbox in the Header table's header
  @ViewChild('headerCheckboxOfHeaderTable') headerCheckboxOfHeaderTable!: Checkbox
  // Checkboxes in the Header table's row
  @ViewChildren('rowCheckboxOfHeaderTable') rowCheckboxesOfHeaderTable!: QueryList<Checkbox>
  // Status for show Header Table
  isHeaderTableOpen: boolean = false;
  // Status for the loading circle on the Header table
  isHeaderTableLoading: boolean = false;
  // Status for enabling a user to edit the data on the Header table
  isHeaderTableInEditMode: boolean = false;
  // All the columns of the Header table have
  columnGroupOfheaderTable: Signal<DateTableColumn[]> = computed(() => [
    { field: 'adNo', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.AdNo', sort: true, filter: { type: 'text' } },
    { field: 'hawbNo', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.HawbNo', sort: true, filter: { type: 'text' } },
    { field: 'importDeclarationNo', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.ImportDeclarationNo', sort: true, filter: { type: 'text' } },
    { field: 'waitingReference', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.WaitingReference', sort: true, filter: { type: 'text' } },
    { field: 'vendorNumber', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.VendorNumber', sort: true, filter: { type: 'text' } },
    { field: 'docStatus', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.DocStatus', sort: true, filter: { type: 'multiselect', multiselectOptions: this.docStatusOptions() } },
    { field: 'facility', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.Facility', sort: true, filter: { type: 'text' } },
    { field: 'notifyUser', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.NotifyUser', sort: true, filter: { type: 'text' } },
    { field: 'notifyDt', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.NotifyDt', sort: true, filter: { type: 'date' } },
    { field: 'notifyFlag', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.NotifyFlag', sort: true, filter: { type: 'multiselect', multiselectOptions: this.emailMarkOptions() } },
    { field: 'replyUser', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.ReplyUser', sort: true, filter: { type: 'text' } },
    { field: 'replyDt', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.ReplyDt', sort: true, filter: { type: 'date' } },
    { field: 'replyFlag', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.ReplyFlag', sort: true, filter: { type: 'multiselect', multiselectOptions: this.emailMarkOptions() } },
    { field: 'createDt', header: 'AdvisingAbnormal.Table.Header.ColumnHeader.CreateDt', sort: true, filter: { type: 'date' } }
  ]);
  
  // The columns user choosing to display on the Header table
  selectedColumnGroupOfHeaderTable: DateTableColumn[] = [];
  // Current data on the Header table
  dataOfheaderTable: AdvisingAbnormalTableHeaderData[] = [];
  // Backup Header data when Header data retrieved from the back-end
  backupDataOfHeaderTable: AdvisingAbnormalTableHeaderData[] = [];
  // User currently selected row on the Header table
  selectedRowOfHeaderTable: AdvisingAbnormalTableHeaderData | null = null;
  // User last selected row on the Header table
  previousSelectedRowOfHeaderTable: AdvisingAbnormalTableHeaderData | null = null;
  // Checked Header Table Row
  checkedRowOfHeaderTable: AdvisingAbnormalTableHeaderData[] = [];
  // Because p-table rowsPerPageOptions any[] cannot set to null on html
  // so use any type variable and set it to p-table rowsPerPageOptions
  rowsPerPageOptionsOfHeaderTable: any = [5, 10, 20];

  // Records for user's operation on the Header table
  updatedHeaderList: AdvisingAbnormalTableHeaderUpdateBean[] = [];

  // Header table paging info
  pageInfoOfHeaderTable: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // Header table sorting info
  sortInfoOfHeaderTable?: { property: string; direction: number };

  //#endregion Header Table Variable

  //#region Detail Table Variable

  readonly detailPreferenceKey: string = UserPreferenceConstants.AdvisingAbnormalTableDetailData;
  // Status for show New Abnormal Item Dialog
  isShowNewAbnormalItemDialog: boolean = false;
  // Status for the loading circle on the Detail table
  isDetailTableLoading: boolean = false;
  // Status for show Detail Table
  isDetailTableOpen: boolean = false;
  // The Detail table for Detail table part
  @ViewChild('detailTable') detailTable!: Table;
  // Checkbox in the Detail table's header
  @ViewChild('headerCheckboxOfDetailTable') headerCheckboxOfDetailTable!: Checkbox
  // Checkboxes in the Detail table's row
  @ViewChildren('rowCheckboxOfDetailTable') rowCheckboxesOfDetailTable!: QueryList<Checkbox>
  // All the columns of the Detail table have
  columnGroupOfDetailTable: DateTableColumn[] = [
    { field: 'externLineNo', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.ExternLineNo', sort: true, filter: { type: 'text' } },
    { field: 'sku', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.SKU', sort: true, filter: { type: 'text' } },
    { field: 'expectedQty', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.ExpectedQty', sort: true, filter: { type: 'numeric' } },
    { field: 'invoiceNo', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.InvoiceNo', sort: true, filter: { type: 'text' } },
    { field: 'receivedDt', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.ReceivedDate', sort: true, filter: { type: 'date' } },
    { field: 'seqNo', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.SeqNo', sort: true, filter: { type: 'numeric' } },
    { field: 'poNo', header: 'AdvisingAbnormal.Table.Detail.ColumnHeader.PoNo', sort: true, filter: { type: 'text' } },
  ];
  // The columns user choosing to display on the Detail table
  selectedColumnGroupOfDetailTable: DateTableColumn[] = [];
  // Current data on the Detail table
  dataOfDetailTable: AdvisingAbnormalTableDetailData[] = [];
  // User currently selected row on the Header table
  selectedRowOfDetailTable: AdvisingAbnormalTableDetailData | null = null;
  // Checked Detail Table Row
  checkedRowOfDetailTable: AdvisingAbnormalTableDetailData[] = [];
  // Because p-table rowsPerPageOptions any[] cannot set to null on html
  // so use any type variable and set it to p-table rowsPerPageOptions
  rowsPerPageOptionsOfDetailTable: any = [5, 10, 20];

  // Detail table paging info
  pageInfoOfDetailTable: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // Detail table sorting info
  sortInfoOfDetailTable?: { property: string; direction: number };

  //#endregion Detail Table Variable

  //#region Abnormal Item Table Variable

  readonly abnormalItemPreferenceKey: string = UserPreferenceConstants.AdvisingAbnormalTableAbnormalItemData;
  // The Abnormal Item table for Abnormal Item table part
  @ViewChild('abnormalItemTable') abnormalItemTable!: Table;
  // Checkbox in the Abnormal Item table's header
  @ViewChild('headerCheckboxOfAbnormalItemTable') headerCheckboxOfAbnormalItemTable!: Checkbox
  // Checkboxes in the Abnormal Item table's row
  @ViewChildren('rowCheckboxOfAbnormalItemTable') rowCheckboxesOfAbnormalItemTable!: QueryList<Checkbox>
  // Status for show Abnormal Item Table
  isAbnormalItemTableOpen: boolean = false;
  // Status for the loading circle on the Abnormal Item table
  isAbnormalItemTableLoading: boolean = false;
  // Status for enabling a user to edit the data on the Abnormal Item table
  isAbnormalItemTableInEditMode: boolean = false;
  // All the columns of the Abnormal Item table have
  columnGroupOfAbnormalItemTable: DateTableColumn[] = [
    { field: 'waitingReference', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.WaitingReference', sort: true },
    { field: 'waitingReferenceDesc', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.WaitingReferenceDesc', sort: true },
    { field: 'abnormalCaseCnt', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.AbnormalCaseCnt', sort: true },
    { field: 'file', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.File', sort: false },
    { field: 'relatedDetailSeqNo', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.RelatedDetailSeqNo', sort: false },
    { field: 'handleMethod', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.HandleMethod', sort: true, filter: { type: 'text' } },
    { field: 'notes', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.Notes', sort: true },
    { field: 'createUser', header: 'AdvisingAbnormal.Table.AbnormalItem.ColumnHeader.CreateUser', sort: true },
  ]
  // The columns user choosing to display on the Abnormal Item table
  selectedColumnGroupOfAbnormalItemTable: DateTableColumn[] = []
  // Current data on the Abnormal Item table
  dataOfAbnormalItemTable: AdvisingAbnormalTableAbnormalItemData[] = [];
  // Backup Abnormal Item data when Abnormal Item data retrieved from the back-end
  backupDataOfAbnormalItemTable: AdvisingAbnormalTableAbnormalItemData[] = [];
  // User current selected row on the Abnormal Item table
  selectedRowOfAbnormalItemTable: AdvisingAbnormalTableAbnormalItemData | null = null;
  // User last selected row on the Abnormal Item table
  previousSelectedRowOfAbnormalItemTable: AdvisingAbnormalTableAbnormalItemData | null = null;
  // Checked Abnormal Item Table Row
  checkedRowOfAbnormalItemTable: AdvisingAbnormalTableAbnormalItemData[] = [];
  // Because p-table rowsPerPageOptions any[] cannot set to null on html
  // so use any type variable and set it to p-table rowsPerPageOptions
  rowsPerPageOptionsOfAbnormalItemTable: any = [5, 10, 20];
  // Subscription for getting File
  getFileSubscribe: Subscription | null = null;

  // Records for user's operation on the table
  newAbnormalItemList: AdvisingAbnormalTableAbnormalItemData[] = [];
  updatedAbnormalItemList: AdvisingAbnormalTableAbnormalItemData[] = [];
  deletedSeqNoGroupOfAbnormalItemTable: number[] = [];

  // For data key to distinguish the added rows on the Abnormal Item table
  newAbnormalItemDataKeyId: number = 0;
  // Abnormal Item table paging info
  pageInfoOfAbnormalItemTable: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // Abnormal Item table sorting info
  sortInfoOfAbnormalItemTable?: { property: string; direction: number };

  // check usertype login as tenant
  isTenant: boolean = false;

  //#endregion Abnormal Item Table Variable

  //#region New Abnormal Item Dialog Variable

  isNewAbnormalItemDialogLoading: boolean = false;
  newAbnormalItemDialogFormGroup: FormGroup;

  //#region File Table Variable

  // The File table for File table part
  @ViewChild('fileTable') fileTable!: Table;
  // All the columns of the File table have
  columnGroupOfFileTable: DateTableColumn[] = [
    { field: 'fileName', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.File.ColumnHeader.FileName', sort: true },
  ]
  // Current data on the Detail table
  dataOfFileTable: File[] = [];

  //#endregion File Table Variable

  //#region Related Detail Table Variable

  @ViewChild('newAbnormalItemDialog') newAbnormalItemDialog!: Dialog;
  // Checkbox in the Related Detail table's header
  @ViewChild('headerCheckboxOfRelatedDetailTable') headerCheckboxOfRelatedDetailTable!: Checkbox
  // Checkboxes in the Related Detail table's row
  @ViewChildren('rowCheckboxOfRelatedDetailTable') rowCheckboxesOfRelatedDetailTable!: QueryList<Checkbox>
  // All the columns of the Related Detail table have
  columnGroupOfRelatedDetailTable: DateTableColumn[] = [
    { field: 'externLineNo', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.ExternLineNo', sort: true },
    { field: 'sku', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.SKU', sort: true },
    { field: 'expectedQty', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.ExpectedQty', sort: true },
    { field: 'invoiceNo', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.InvoiceNo', sort: true },
    { field: 'receivedDt', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.ReceivedDate', sort: true },
    { field: 'seqNo', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.SeqNo', sort: true },
  ];
  // The columns user choosing to display on the Related Detail table
  selectedColumnGroupOfRelatedDetailTable: DateTableColumn[] = [];
  // Current data on the Related Detail table
  dataOfRelatedDetailTable: AdvisingAbnormalTableDetailData[] = [];
  // Checked Related Detail Table Row
  checkedRowOfRelatedDetailTable: AdvisingAbnormalTableDetailData[] = [];

  //#endregion File Table Variable

  //#endregion New Abnormal Item Dialog Variable

  //#region Abnormal Item File Dialog Variable

  @ViewChild('abnormalItemFileDialog') abnormalItemFileDialog!: Dialog
  isShowAbnormalItemFileDialog: boolean = false;
  isAbnormalItemFileDialogLoading: boolean = false;
  isShowBigFile: boolean = false;
  readonly ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM = AbnormalItemFileDialogMode;
  abnormalItemFileDialogMode: AbnormalItemFileDialogMode = AbnormalItemFileDialogMode.Edit;

  // Abnormal Item File Dialog data
  fileDocIdOfCurrentAbnormalItem: string[] = [];
  fileOfAbnormalItemFileDialog: AdvisingAbnormalDialogItemFile[] = [];
  backupFileOfAbnormalItemFileDialog: AdvisingAbnormalDialogItemFile[] = [];

  // Index for Galleria
  indexOfGalleria: number = 0;

  // Records for user's operation on this dialog
  newAbnormalItemFileBase64s: AdvisingAbnormalItemFileBase64Bean[] = [];
  deletedAbnormalItemFileDocIds: string[] = [];

  // fileDeletePermission
  filePermission: boolean | null;

  //#endregion Abnormal Item File Dialog Function

  //#region initial Option

  private initAllOption() {
    this.initFacilityOption();
    this.initDocStatusOption();
    this.initVendorNumberOption();
    this.initEmailMarkOption();
    this.initWaitingReferenceOptionOfHeaderTable();
    this.initWaitingReferenceOptionOfAbnormalItemTable();
    this.initPcsrAndCsrOption();
  }

  private initFacilityOption() {
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options;
      }
    })
  }

  private initDocStatusOption() {
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'advising').subscribe({
      next: (options) => {
        this.docStatusOptions.set(options?.map((option: { codeDesc: string; codeKey: string }) => ({
          label: option.codeDesc,
          value: option.codeKey
        })) || []);
      }
    })
  }

  private initVendorNumberOption() {
    this.facilityService.getAllVendorOptions().subscribe({
      next: (options) => {
        this.vendorNumberOptions = options?.map((option: { optionCode: string; optionDesc: string }) => ({
          label: `${option.optionCode} - ${option.optionDesc}`,
          value: option.optionCode
        }));
      }
    })
  }

  private initEmailMarkOption() {
    this.emailMarkOptions.set([
      { label: 'Y', value: 1 },
      { label: 'N', value: 0 }
    ]);
  }

  private initWaitingReferenceOptionOfHeaderTable() {
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'AdvisingAbnormalHeader').subscribe({
      next: (options) => {
        this.waitingReferenceOptionsOfHeaderTable = options?.map((option: { codeDesc: string; codeKey: string }) => ({
          label: option.codeDesc,
          value: option.codeKey
        })) || [];
      }
    })
  }

  private initWaitingReferenceOptionOfAbnormalItemTable() {
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'AdvisingAbnormalDetail').subscribe({
      next: (options) => {
        this.waitingReferenceOptionsOfAbnormalItemTable = options?.map((option: { codeDesc: string; codeKey: string }) => ({
          label: option.codeDesc,
          value: option.codeKey
        })) || [];
      }
    })
  }

  private initPcsrAndCsrOption() {
    this.dropdownOptionsService.getPcsrAndCsrOptions().subscribe({
      next: (options: any[]) => {
        this.pcsrAndCsrOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
  }

  //#endregion initial Option

  //#region initial Table

  private initAllTable(): void {
    this.initRelatedDetailTable();
  }

  private initRelatedDetailTable(): void {
    this.selectedColumnGroupOfRelatedDetailTable = this.columnGroupOfRelatedDetailTable;
  }

  //#endregion initial Table

  //#endregion Constructor

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.initAllOption();

    // get param to auto query
    this.route.queryParams.subscribe((params: Params) => {
      params = Object.values(params);
      const replied = params.slice(1, 2);

      if (params.length != 0) {
        const adNo = params[0].split(";");
        this.searchFormGroup.value.adNo = adNo;
        this.searchFormGroup.controls["adNo"].setValue(adNo);

        let headerTableGetRequest: AdvisingAbnormalTableHeaderGetRequest = this.createHeaderGetRequest();
        const did = 1;
        // 已通知，value = 1，因為收到信一定是已通知，所以預設notified一定為Y
        this.searchFormGroup.value.notified = headerTableGetRequest.notified = did;

        // 已回覆，value = 1，預設replied為空，PCSR已回覆才會為Y
        if (replied.length != 0) {
          this.searchFormGroup.value.replied = headerTableGetRequest.replied = did;
        }
        this.searchBtnClick();

      }
      this.isTenant = this.userProfile.userType == "Tenant" ? false : true;

    });
  }

  //#endregion Table Column Filter

  //#region Window resize Function

  onWindowResize() {
    if (window.innerWidth <= this.MOBILE_MODE_WINDOW_WIDTH) {
      this.changeToMobileMode();
    }
    else {
      this.changeToDesktopMode();
    }
  }

  isInDesktopMode(): boolean {
    return this.displayMode === this.DISPLAY_MODE_ENUM.Desktop;
  }

  private changeToMobileMode() {
    this.displayMode = DisplayMode.Mobile
    this.rowsPerPageOptionsOfHeaderTable = null;
    this.rowsPerPageOptionsOfDetailTable = null;
    this.rowsPerPageOptionsOfAbnormalItemTable = null;
  }

  private changeToDesktopMode() {
    this.displayMode = DisplayMode.Desktop
    this.rowsPerPageOptionsOfHeaderTable = [5, 10, 20];
    this.rowsPerPageOptionsOfDetailTable = [5, 10, 20];
    this.rowsPerPageOptionsOfAbnormalItemTable = [5, 10, 20];
  }

  //#endregion Window resize Function

  //#region Search Form Function

  /**
   * Add Chips Item by comma ',' in mobile version
   */
  addItemByComma(event: Event, chips: Chips) {
    if ((event as InputEvent).data === ',') {
      let value = chips.inputViewChild.nativeElement.value.slice(0, -1);
      if (value !== '') {
        chips.addItem(event, value, true);
      }
    }
  }

  /**
   * Handle form Hawb No added event
   */
  hawbNoChipsAdd(event: { originalEvent: Event, value: string }): void {
    const eventValue: string = event.value;
    const parsedValues: string[] = eventValue.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchFormGroup.value.hawbNo.pop()
    for (let value of parsedValues) {
      this.searchFormGroup.value.hawbNo.push(value)
    }
  }

  /**
   * handle form Ad No added event
   */
  adNoChipsAdd(event: { originalEvent: Event, value: string }): void {
    const eventValue: string = event.value;
    const parsedValues: string[] = eventValue.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchFormGroup.value.adNo.pop()
    for (let value of parsedValues) {
      this.searchFormGroup.value.adNo.push(value)
    }
  }

  /**
   * handle form Invoice No added event
   */
  invoiceNoChipsAdd(event: { originalEvent: Event, value: string }): void {
    const eventValue: string = event.value;
    const parsedValues: string[] = eventValue.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchFormGroup.value.invoiceNo.pop()
    for (let value of parsedValues) {
      this.searchFormGroup.value.invoiceNo.push(value)
    }
  }

  /**
   * Check if user input one of those required fields
   */
  checkRequiredField(): boolean {
    if (this.searchFormGroup.value.notified == 1 && this.searchFormGroup.value.replied == 1) {
      if (
        !this.isRequiredFieldFilled(this.searchFormGroup.value.vendorNumber)
        && !this.isRequiredFieldFilled(this.searchFormGroup.value.hawbNo)
        && !this.isRequiredFieldFilled(this.searchFormGroup.value.adNo)
        && !this.isRequiredFieldFilled(this.searchFormGroup.value.invoiceNo)
      ) {
        return true;
      }
    }
    return false;
  }

  private isRequiredFieldFilled(values: string[]) {
    return !isNullOrEmpty(values) && values.length > 0;
  }

  searchBtnClick() {
    if (this.checkRequiredField()) {
      this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Form.Toast.NoInputAnyRequiredField'))
      return;
    }
    this.mobileTabPanelActiveIndex = 1;
    this.isSearchFormOpen = false;

    this.isHeaderTableOpen = true;
    this.isHeaderTableInEditMode = false;

    this.pageInfoOfHeaderTable.pageIndex = 0;
    this.headerTable.first = 0;
    this.getHeaderTableData();
  }

  resetSearchForm() {
    this.searchFormGroup.reset()
    this.searchFormGroup.controls['orderQueryScope'].setValue(OrderQueryScopeEnum.personal);
  }

  private getHeaderTableData() {

    this.restoreHeaderInternalData();

    let headerTableGetRequest: AdvisingAbnormalTableHeaderGetRequest = this.createHeaderGetRequest();

    this.isHeaderTableLoading = true;

    this.advisingAbnormalService.findAdvisingAbnormalHeader(headerTableGetRequest)
      .pipe(finalize(() => (this.isHeaderTableLoading = false)))
      .subscribe({
        next: (response) => {
          this.headerTable.cancelRowEdit(this.selectedRowOfHeaderTable);
          if (!isNullOrEmpty(response) && !isNullOrEmpty(response.content)) {
            this.setHeaderDataByServiceResponse(response);
            if (this.selectedRowOfHeaderTable?.adNo) {
              this.isDetailTableOpen = true;
              this.pageInfoOfDetailTable.pageIndex = 0;
              this.detailTable.first = 0;
              this.getDetailTableData();

              this.isAbnormalItemTableOpen = true;
              this.isAbnormalItemTableInEditMode = false;
              this.pageInfoOfAbnormalItemTable.pageIndex = 0;
              this.abnormalItemTable.first = 0;
              this.getAbnormalItemTableData();
            }
            else {
              this.clearDetailTable();
              this.clearAbnormalItemTable()
            }
          }
          else {
            throwError(response);
          }
        },
        error: (response) => {
          this.clearHeaderTable();
          this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Failure.GetDataFail') + response.status);
        },
        complete: () => {
          this.headerCheckboxOfHeaderTable.writeValue(false);
        }
      });
  }

  private createHeaderGetRequest(): AdvisingAbnormalTableHeaderGetRequest {
    let headerTableGetRequest: AdvisingAbnormalTableHeaderGetRequest = new AdvisingAbnormalTableHeaderGetRequest();

    // Page information
    headerTableGetRequest.pageIndex = this.pageInfoOfHeaderTable.pageIndex;
    headerTableGetRequest.pageSize = this.pageInfoOfHeaderTable.pageSize;
    const propertyIsNullOrEmpty = isNullOrEmpty(this.sortInfoOfHeaderTable) || isNullOrEmpty(this.sortInfoOfHeaderTable?.property);
    const directionIsNullOrEmpty = isNullOrEmpty(this.sortInfoOfHeaderTable) || isNullOrEmpty(this.sortInfoOfHeaderTable?.direction);
    const sortOrder: SortOrder = {
      property: propertyIsNullOrEmpty ? 'AdNo,HawbNo' : this.sortInfoOfHeaderTable?.property,
      direction: directionIsNullOrEmpty ? -1 : this.sortInfoOfHeaderTable?.direction
    };
    headerTableGetRequest.sortOrder = sortOrder;

    // User role
    headerTableGetRequest.userDataScopes = getDataScopeByPermission(this.userProfile, PermissionConstants.ViewAdvisingAbnormal);
    headerTableGetRequest.roleCodes = this.convertEmptyStringArrayToNull(this.userProfile.roles.map((role: { roleCode: any; }) => role.roleCode));
    headerTableGetRequest.userType = this.userProfile.userType;
    headerTableGetRequest.userEmail = this.userService.userInfo.email;

    // Query parameters
    headerTableGetRequest.orderQueryScope = this.searchFormGroup.value.orderQueryScope;
    headerTableGetRequest.notified = this.searchFormGroup.value.notified;
    headerTableGetRequest.replied = this.searchFormGroup.value.replied;
    headerTableGetRequest.facilities = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.facility);
    headerTableGetRequest.vendorNumber = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.vendorNumber);
    headerTableGetRequest.hawbNo = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.hawbNo);
    headerTableGetRequest.adNo = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.adNo);
    headerTableGetRequest.invoiceNo = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.invoiceNo);
    headerTableGetRequest.pcsrAndCsrList = this.searchFormGroup.value.pcsrAndCsrList;

    return headerTableGetRequest;
  }

  private convertEmptyStringArrayToNull(value: string[]): string[] | null {
    if (isNullOrEmpty(value) || value.length <= 0) {
      return null;
    }
    return value;
  }

  private setHeaderDataByServiceResponse(response: PageResp<AdvisingAbnormalTableHeaderData>) {
    this.clearTableFilter(this.headerTable);
    // Update Table
    this.dataOfheaderTable = deepCopy(response.content) ?? [];
    this.dataOfheaderTable = this.dataOfheaderTable.map((x: any) => {
      x.vendorNumber = (x.vendorNumber == null ? '' : x.vendorNumber) + '-' + (x.vendorName == null ? '' : x.vendorName);
      return x;
    });


    this.backupDataOfHeaderTable = deepCopy(this.dataOfheaderTable) ?? [];
    this.selectedRowOfHeaderTable = this.dataOfheaderTable[0];
    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;
    this.updateHeaderTableHighlight(this.selectedRowOfHeaderTable)

    if (this.isHeaderTableInEditMode) {
      this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
    }

    // Change page Info
    this.pageInfoOfHeaderTable.totalRecords = response.totalElements;
    this.pageInfoOfHeaderTable.totalPages = this.pageInfoOfHeaderTable.totalRecords / this.pageInfoOfHeaderTable.pageSize;
  }

  private clearDetailTable() {
    this.clearTableFilter(this.detailTable);
    this.dataOfDetailTable = [];
    this.selectedRowOfDetailTable = null;
    this.pageInfoOfDetailTable.totalRecords = 0;
    this.pageInfoOfDetailTable.totalPages = 0;
  }

  private clearHeaderTable() {
    this.clearTableFilter(this.headerTable);
    this.dataOfheaderTable = [];
    this.backupDataOfHeaderTable = [];
    this.selectedRowOfHeaderTable = null;
    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;
    this.pageInfoOfHeaderTable.totalRecords = 0;
    this.pageInfoOfHeaderTable.totalPages = 0;
  }

  private getDetailTableData() {

    this.restoreDetailInternalData();

    let detailTableGetRequest = this.createDetailGetRequest();

    this.isDetailTableLoading = true;

    this.advisingAbnormalService.findAdvisingAbnormalDetail(detailTableGetRequest)
      .pipe(finalize(() => (this.isDetailTableLoading = false)))
      .subscribe({
        next: (response) => {
          if (!isNullOrEmpty(response) && !isNullOrEmpty(response.content)) {
            this.setDetailDataByServiceResponse(response);
          }
          else {
            throwError(response);
          }
        },
        error: (response) => {
          this.clearDetailTable();
          this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.Detail.Toast.Failure.GetDataFail') + response.status);
        }
      });
  }

  private createDetailGetRequest(): AdvisingAbnormalTableDetailGetRequest {
    let detailTableGetRequest: AdvisingAbnormalTableDetailGetRequest = new AdvisingAbnormalTableDetailGetRequest();
    detailTableGetRequest.adNo = this.selectedRowOfHeaderTable?.adNo ?? '';
    detailTableGetRequest.pageIndex = this.pageInfoOfDetailTable.pageIndex;
    detailTableGetRequest.pageSize = this.pageInfoOfDetailTable.pageSize;
    const propertyIsNullOrEmpty = isNullOrEmpty(this.sortInfoOfDetailTable) || isNullOrEmpty(this.sortInfoOfDetailTable?.property);
    const directionIsNullOrEmpty = isNullOrEmpty(this.sortInfoOfDetailTable) || isNullOrEmpty(this.sortInfoOfDetailTable?.direction);
    const sortOrder: SortOrder = {
      property: propertyIsNullOrEmpty ? 'InvoiceNo' : this.sortInfoOfDetailTable?.property,
      direction: directionIsNullOrEmpty ? -1 : this.sortInfoOfDetailTable?.direction
    };
    detailTableGetRequest.sortOrder = sortOrder;
    return detailTableGetRequest;
  }

  private setDetailDataByServiceResponse(response: PageResp<AdvisingAbnormalTableDetailData>) {
    this.clearTableFilter(this.detailTable);
    // Update Table
    this.dataOfDetailTable = deepCopy(response.content) ?? [];

    // Change page Info
    this.pageInfoOfDetailTable.totalRecords = response.totalElements;
    this.pageInfoOfDetailTable.totalPages = this.pageInfoOfDetailTable.totalRecords / this.pageInfoOfDetailTable.pageSize;
  }

  private getAbnormalItemTableData() {
    this.isAbnormalItemTableLoading = true;
    this.restoreAbnormalItemInternalData();

    let abnormalItemTableGetRequest: AdvisingAbnormalTableAbnormalItemGetRequest = this.createAbnormalItemGetRequest();
    this.advisingAbnormalService.findAdvisingAbnormalItem(abnormalItemTableGetRequest).subscribe({
      next: (response) => {
        this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
        if (!isNullOrEmpty(response) && !isNullOrEmpty(response.content)) {
          this.setAbnormalItemDataByServiceResponse(response);
        }
        else {
          throwError(response);
        }
      },
      error: (response) => {
        this.clearAbnormalItemTable();
        this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Failure.GetDataFail') + response.status);
      },
      complete: () => {
        this.isAbnormalItemTableLoading = false;
      }
    })
  }

  private createAbnormalItemGetRequest(): AdvisingAbnormalTableAbnormalItemGetRequest {
    let abnormalItemTableGetRequest: AdvisingAbnormalTableAbnormalItemGetRequest = new AdvisingAbnormalTableAbnormalItemGetRequest();
    abnormalItemTableGetRequest.adNo = this.selectedRowOfHeaderTable?.adNo ?? '';
    abnormalItemTableGetRequest.detailSeqNo = this.selectedRowOfDetailTable?.seqNo ?? null;
    abnormalItemTableGetRequest.pageIndex = this.pageInfoOfAbnormalItemTable.pageIndex;
    abnormalItemTableGetRequest.pageSize = this.pageInfoOfAbnormalItemTable.pageSize;
    const propertyIsNullOrEmpty = isNullOrEmpty(this.sortInfoOfAbnormalItemTable) || isNullOrEmpty(this.sortInfoOfAbnormalItemTable?.property);
    const directionIsNullOrEmpty = isNullOrEmpty(this.sortInfoOfAbnormalItemTable) || isNullOrEmpty(this.sortInfoOfAbnormalItemTable?.direction);
    const sortOrder: SortOrder = {
      property: propertyIsNullOrEmpty ? 'SeqNo' : this.sortInfoOfAbnormalItemTable?.property,
      direction: directionIsNullOrEmpty ? -1 : this.sortInfoOfAbnormalItemTable?.direction
    };
    abnormalItemTableGetRequest.sortOrder = sortOrder;
    return abnormalItemTableGetRequest;
  }

  private setAbnormalItemDataByServiceResponse(response: PageResp<AdvisingAbnormalTableAbnormalItemData>) {
    this.clearTableFilter(this.abnormalItemTable);
    // Update Table
    this.dataOfAbnormalItemTable = deepCopy(response.content) ?? [];
    this.backupDataOfAbnormalItemTable = deepCopy(this.dataOfAbnormalItemTable) ?? [];
    this.selectedRowOfAbnormalItemTable = this.dataOfAbnormalItemTable[0];

    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
    this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable)

    if (this.isAbnormalItemTableInEditMode) {
      this.headerTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
    }

    // Change page Info
    this.pageInfoOfAbnormalItemTable.totalRecords = response.totalElements;
    this.pageInfoOfAbnormalItemTable.totalPages = this.pageInfoOfAbnormalItemTable.totalRecords / this.pageInfoOfAbnormalItemTable.pageSize;
  }

  private clearTableFilter(table: Table) {
    table.clearFilterValues();
    table.filteredValue = null;
    table.saveState();
  }

  private clearAbnormalItemTable() {
    this.clearTableFilter(this.abnormalItemTable);
    this.dataOfAbnormalItemTable = [];
    this.backupDataOfAbnormalItemTable = [];
    this.selectedRowOfAbnormalItemTable = null;
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
    this.pageInfoOfAbnormalItemTable.totalRecords = 0;
    this.pageInfoOfAbnormalItemTable.totalPages = 0;
  }

  //#endregion Search Form Function

  //#region Table Common Function

  isAbleToEdit(): boolean {
    return !isNullOrEmpty(this.selectedRowOfHeaderTable)
  }

  isAbleToUpload(): boolean {
    return !isNullOrEmpty(this.selectedRowOfHeaderTable)
      && this.checkedRowOfDetailTable.length > 0
  }

  // Prevent children event trigger parent event
  stopBubblingPhases(event: Event) {
    event.stopPropagation()
  }

  getWaitingReferenceDescOfHeaderTableByItsCode(waitingReferenceCode: string): string | null {
    return this.waitingReferenceOptionsOfHeaderTable.find(waitingReferenceOption =>
      waitingReferenceOption.value == waitingReferenceCode)?.label ?? null;
  }


  getWaitingReferenceDescOfAbnormalItemTableByItsCode(waitingReferenceCode: string): string | null {
    return this.waitingReferenceOptionsOfAbnormalItemTable.find(waitingReferenceOption =>
      waitingReferenceOption.value == waitingReferenceCode)?.label ?? null;
  }


  getDocStatusDescByItsCode(docStatusCode: string): string | null {
    return this.docStatusOptions().find(docStatusOption =>
      docStatusOption.value == docStatusCode)?.label ?? null;
  }

  //#endregion Table Common Function

  //#region Header Table Function

  isAbleToSendMail(): boolean {
    return this.checkedRowOfHeaderTable.length > 0;
  }

  async askConfirmationForSendNotification() {
    let checkNotAbnormalAd = await this.checkNotAbnormalAd();
    if (!checkNotAbnormalAd) {
      return;
    }

    let secondConfirmationMessage: string | null = await new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
        message: this.translateService.instant('AdvisingAbnormal.Table.Header.Confirm.Notify'),
        icon: 'pi pi-info-circle',
        accept: () => {
          resolve(this.getNotificationSecondConfirmationMessage());
        }
      });
    })

    if (secondConfirmationMessage) {
      this.askSecondConfirmationForSendNotification(secondConfirmationMessage);
    }
    else {
      this.sendNotification();
    }
  }

  async askConfirmationForReplyNotification() {
    let checkNotAbnormalAd = await this.checkNotAbnormalAd();
    if (!checkNotAbnormalAd) {
      return;
    }

    let secondConfirmationMessage: string | null = await new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
        message: this.translateService.instant('AdvisingAbnormal.Table.Header.Confirm.Reply'),
        icon: 'pi pi-info-circle',
        accept: () => {
          resolve(this.getReplySecondConfirmationMessage());
        }
      });
    });

    if (secondConfirmationMessage) {
      this.askSecondConfirmationForReplyNotification(secondConfirmationMessage);
    }
    else {
      this.replyNotification();
    }
  }

  saveDataChangesOnHeaderTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Table.Header.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.checkUpdatedWaitingReference();
        if (this.updatedHeaderList.length > 0) {
          let headerUpdateRequest: AdvisingAbnormalTableHeaderUpdateRequest = this.createRequestForUpdateHeader();

          this.isHeaderTableLoading = true;
          this.advisingAbnormalService.updateHeader(headerUpdateRequest).subscribe({
            next: () => {
              this.getHeaderTableData();
              this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Success.SaveSuccess'));
            },
            error: response => {
              this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Failure.SaveFail') + response.status);
            },
            complete: () => {
              this.headerTable.cancelRowEdit(this.selectedRowOfHeaderTable);
              this.isHeaderTableInEditMode = false;
              this.isHeaderTableLoading = false;
            }
          });
        }
      }
    });
  }

  restoreDataOnHeaderTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Table.Header.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreHeader();
        this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
        this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Success.RestoreSuccess'))
      }
    })
  }

  switchEditModeOnHeaderTable() {
    if (this.isHeaderTableInEditMode) {
      this.confirmationService.confirm({
        header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
        message: this.translateService.instant('AdvisingAbnormal.Table.Header.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isHeaderTableInEditMode = false;
          this.restoreHeader();
          this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Success.EditingCancelSuccess'))
        }
      })
    }
    else {
      this.isHeaderTableInEditMode = true;
      if (!isNullOrEmpty(this.selectedRowOfHeaderTable)) {
        this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
      }
    }
  }

  toggleAllRowCheckboxOnHeaderTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfHeaderTable.writeValue(!this.headerCheckboxOfHeaderTable.checked())
    }

    this.rowCheckboxesOfHeaderTable.toArray().forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfHeaderTable.checked());
    })
    this.checkedRowOfHeaderTable = this.headerCheckboxOfHeaderTable.checked() ? deepCopy(this.dataOfheaderTable) ?? [] : [];
  }

  toggleRowCheckboxOnHeaderTable(event: { checked?: any }, rowData: AdvisingAbnormalTableHeaderData) {

    if (event.checked) {
      this.checkedRowOfHeaderTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfHeaderTable.findIndex(checkedRowData => checkedRowData.rownum == rowData.rownum);
      this.checkedRowOfHeaderTable.splice(removedIndex, 1);
    }
  }

  selectRowOnHeaderTable(rowData: AdvisingAbnormalTableHeaderData) {
    this.selectedRowOfHeaderTable = rowData;

    // Keep the selectedHeaderTableRow variable is pointing at the user's selected row
    // Whether is select or deselect
    if (this.isReselectHeaderTableRow()) {
      this.updateHeaderTableHighlight(this.previousSelectedRowOfHeaderTable);
      return;
    }

    if (this.isHeaderTableInEditMode) {
      // Change the current selected Header row to the user's selected Header row
      this.headerTable.cancelRowEdit(this.previousSelectedRowOfHeaderTable);
      this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
    }

    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;
    this.getDetailTableData();
    this.getAbnormalItemTableData();
  }

  pagingOnHeaderTable(event: { first: number, rows: number }) {
    this.pageInfoOfHeaderTable.pageSize = event.rows;
    this.pageInfoOfHeaderTable.pageIndex = event.first / event.rows;

    this.getHeaderTableData();
  }

  sortingOnHeaderTable(event: { field: string, order: number }) {
    if (this.dataOfheaderTable.length > 0) {
      this.sortInfoOfHeaderTable = { property: event.field, direction: event.order };
      this.getHeaderTableData();
    }
  }

  async setHeaderPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfoOfHeaderTable.pageSize = event.rows;
  }

  private createRequestForUpdateHeader(): AdvisingAbnormalTableHeaderUpdateRequest {
    let headerUpdateRequest: AdvisingAbnormalTableHeaderUpdateRequest = new AdvisingAbnormalTableHeaderUpdateRequest();
    headerUpdateRequest.updatedHeaders = this.updatedHeaderList;
    headerUpdateRequest.userName = this.userService.userInfo.userName;
    headerUpdateRequest.operationDate = new Date();
    return headerUpdateRequest;
  }

  private getNotificationSecondConfirmationMessage(): string | null {
    let notifiedAdNos: string[] = this.checkNotifiedAbnormalAd();
    return this.createWarningMessageForNotification(notifiedAdNos);
  }

  private checkNotifiedAbnormalAd(): string[] {
    let notifiedAbnormalAdNos: string[] = [];
    for (let advisingAbnormal of this.checkedRowOfHeaderTable) {
      if (advisingAbnormal.notifyFlag === 1) {
        notifiedAbnormalAdNos.push(advisingAbnormal.adNo);
      }
    }
    return notifiedAbnormalAdNos;
  }

  private createWarningMessageForNotification(notifiedAdNos: string[]): string | null {
    let message = ''
    if (notifiedAdNos.length > 0) {
      message += this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Warning.HadNotified');
      for (let adNo of notifiedAdNos) {
        message += `\n${adNo}`;
      }
    }

    return message != '' ? message : null;
  }

  private askSecondConfirmationForSendNotification(message: string) {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: message,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.sendNotification();
      }
    });
  }

  private sendNotification() {
    this.isHeaderTableLoading = true;
    let advisingAbnormalMailRequest: AdvisingAbnormalMailRequest = this.createAdvisingAbnormalMailRequest();
    this.advisingAbnormalService.sendNotification(advisingAbnormalMailRequest, this.laasSetting.language).subscribe({
      next: () => {
        this.getHeaderTableData();
        this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Success.NotifySuccess'));
      },
      error: (error) => {
        if (error.error != null && error.error.category == this.ERROR_CODE_CATEGORY) {
          this.toastErrorMessage(error.error)
        }
        else {
          this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Failure.NotifyFail'));
        }
        this.isHeaderTableLoading = false;
      },
      complete: () => {
        this.isHeaderTableLoading = false;
      }
    })
  }

  private getReplySecondConfirmationMessage(): string | null {
    let repliedAdNos: string[] = this.checkRepliedAbnormalAd();
    return this.createWarningMessageForReplyNotification(repliedAdNos);
  }

  private checkRepliedAbnormalAd(): string[] {
    let notifiedAbnormalAdNos: string[] = [];
    for (let advisingAbnormal of this.checkedRowOfHeaderTable) {
      if (advisingAbnormal.replyFlag === 1) {
        notifiedAbnormalAdNos.push(advisingAbnormal.adNo);
      }
    }
    return notifiedAbnormalAdNos;
  }

  private createWarningMessageForReplyNotification(repliedAdNos: string[]): string | null {
    let message = ''
    if (repliedAdNos.length > 0) {
      message += this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Warning.HadReplied');
      for (let adNo of repliedAdNos) {
        message += `\n${adNo}`;
      }
    }

    return message != '' ? message : null;
  }

  private askSecondConfirmationForReplyNotification(message: string) {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: message,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.replyNotification();
      }
    });
  }

  private replyNotification() {
    this.isHeaderTableLoading = true;
    let advisingAbnormalMailRequest: AdvisingAbnormalMailRequest = this.createAdvisingAbnormalMailRequest();
    this.advisingAbnormalService.replyNotification(advisingAbnormalMailRequest, this.laasSetting.language).subscribe({
      next: () => {
        this.getHeaderTableData();
        this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Success.ReplySuccess'));
      },
      error: response => {
        if (response.error != null && response.error.category == this.ERROR_CODE_CATEGORY) {
          this.toastErrorMessage(response.error)
        }
        else {
          this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Failure.ReplyFail') + response.status);
        }
        this.isHeaderTableLoading = false;
      },
      complete: () => {
        this.isHeaderTableLoading = false;
      }
    })
  }

  private async checkNotAbnormalAd(): Promise<boolean> {
    let errorMsg: string = '';
    const adNoList: string[] = [];

    for (let advisingAbnormal of this.checkedRowOfHeaderTable) {
      adNoList.push(advisingAbnormal.adNo);
    }

    try {
      let advisingHeaderInfoList = await this.advisingServiceService.queryAdHeaderInfo(adNoList);
      advisingHeaderInfoList.forEach((adHeader: AdHeaderInfoResponse) => {
        if (adHeader.docStatus !== '42') {
          errorMsg += `\n${adHeader.adNo}`
        }
      });
    } catch (err: any) {
      this.toastErrorMessage(err.error);
      return false;
    }

    if (errorMsg != '') {
      errorMsg = this.translateService.instant('AdvisingAbnormal.Table.Header.Toast.Warning.NotAbnormal') + errorMsg;
      this.toastService.warn(errorMsg);
      return false;
    }
    return true;
  }

  private createAdvisingAbnormalMailRequest(): AdvisingAbnormalMailRequest {
    let advisingAbnormalMailRequest = new AdvisingAbnormalMailRequest();
    let adNos: string[] = [];
    let facilities: string[] = [];

    for (let advisingAbnormal of this.checkedRowOfHeaderTable) {
      adNos.push(advisingAbnormal.adNo)
      facilities.push(advisingAbnormal.facility ?? null)
    }

    advisingAbnormalMailRequest.adNos = adNos;
    advisingAbnormalMailRequest.facilities = facilities;
    advisingAbnormalMailRequest.userName = this.userService.userInfo.userName;
    advisingAbnormalMailRequest.operationDate = new Date();
    return advisingAbnormalMailRequest;
  }

  private checkUpdatedWaitingReference() {
    for (let i = 0; i < this.backupDataOfHeaderTable.length; i++) {
      if (this.dataOfheaderTable[i].waitingReference !== this.backupDataOfHeaderTable[i].waitingReference) {
        this.addToHeaderUpdateList(this.dataOfheaderTable[i]);
      }
    }
  }

  private addToHeaderUpdateList(headerData: AdvisingAbnormalTableHeaderData) {
    let updateHeaderBean = new AdvisingAbnormalTableHeaderUpdateBean();
    updateHeaderBean.adNo = headerData.adNo;
    updateHeaderBean.waitingReference = headerData.waitingReference ?? null;
    this.updatedHeaderList.push(updateHeaderBean);
  }

  // Check if user reselect selected Header row
  private isReselectHeaderTableRow(): boolean {
    return this.previousSelectedRowOfHeaderTable != null && this.previousSelectedRowOfHeaderTable.rownum === this.selectedRowOfHeaderTable?.rownum;
  }

  private restoreHeader() {
    this.restoreHeaderTable();
    this.restoreHeaderInternalData();
  }

  private restoreHeaderTable() {
    this.dataOfheaderTable = deepCopy(this.backupDataOfHeaderTable)!;
    this.cancelHeaderTableEdit();
  }

  // Cancel current Header table's row editing
  private cancelHeaderTableEdit() {
    this.headerTable.cancelRowEdit(this.selectedRowOfHeaderTable);
    this.selectedRowOfHeaderTable = this.dataOfheaderTable[0];
    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;

    // Avoid the highlighted part leave on the previous Header row
    this.updateHeaderTableHighlight(this.selectedRowOfHeaderTable);
  }

  private restoreHeaderInternalData(): void {
    // Clear user changed action in Header table
    this.checkedRowOfHeaderTable = [];
    this.headerCheckboxOfHeaderTable.writeValue(false);

    this.updatedHeaderList = [];
    this.headerTable.resetScrollTop();
  }

  // Control the selection highlight to the specific Header row
  private updateHeaderTableHighlight(selectedRow: AdvisingAbnormalTableHeaderData | null): void {
    if (!selectedRow) {
      return;
    }
    this.headerTable.selection = selectedRow;
    this.headerTable.selectionKeys = {};
    this.headerTable.selectionKeys[selectedRow.rownum] = 1;
    this.headerTable.tableService.onSelectionChange();
  }

  //#endregion Header Table Function

  //#region Detail Table Function

  showUploadFileDialog() {
    this.isShowNewAbnormalItemDialog = true;
    this.keepDialogToFullScreenInMobileMode(this.newAbnormalItemDialog);
    this.dataOfRelatedDetailTable = deepCopy(this.checkedRowOfDetailTable) ?? [];
  }

  toggleAllRowCheckboxOnDetailTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfDetailTable.writeValue(!this.headerCheckboxOfDetailTable.checked())
    }

    this.rowCheckboxesOfDetailTable.toArray().forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfDetailTable.checked());
    })

    this.checkedRowOfDetailTable = this.headerCheckboxOfDetailTable.checked() ? deepCopy(this.dataOfDetailTable) ?? [] : [];
  }

  toggleRowCheckboxOnDetailTable(event: { checked?: any }, rowData: AdvisingAbnormalTableDetailData) {
    if (event.checked) {
      this.checkedRowOfDetailTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfDetailTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfDetailTable.splice(removedIndex, 1);
    }
  }

  selectRowOnDetailTable() {
    this.getAbnormalItemTableData();
  }

  pagingOnDetailTable(event: { first: number, rows: number }) {
    this.pageInfoOfDetailTable.pageSize = event.rows;
    this.pageInfoOfDetailTable.pageIndex = event.first / event.rows;

    this.getDetailTableData();
  }

  sortingOnDetailTable(event: { field: string, order: number }) {
    if (this.dataOfDetailTable.length > 0) {
      this.sortInfoOfDetailTable = { property: event.field, direction: event.order };
      this.getDetailTableData();
    }
  }

  async setDetailPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfoOfDetailTable.pageSize = event.rows;
  }

  private restoreDetailInternalData(): void {
    // Clear user changed action
    this.checkedRowOfDetailTable = [];
    this.headerCheckboxOfDetailTable.writeValue(false);

    if (!this.isInDesktopMode) {
      this.detailTable.resetScrollTop();
    }
  }

  //#endregion Detail Table Function

  //#region Abnormal Item Table Function

  addRowOnAbnormalItemTable() {
    if (!this.isUserInputValidOnAbnormalItemTable(this.previousSelectedRowOfAbnormalItemTable)) {
      return;
    }

    // Add a new row to AbnormalItem table's first row
    let newAbnormalItemData = new AdvisingAbnormalTableAbnormalItemData();
    newAbnormalItemData.createUser = this.userService.userInfo.userName;
    newAbnormalItemData.createDt = new Date();
    newAbnormalItemData.updateUser = this.userService.userInfo.userName;
    newAbnormalItemData.updateDt = new Date();
    newAbnormalItemData.dataKey = `--${this.newAbnormalItemDataKeyId++}`;
    newAbnormalItemData.adNo = this.selectedRowOfHeaderTable?.adNo ?? "";

    this.dataOfAbnormalItemTable.splice(0, 0, newAbnormalItemData)
    this.clearAbnormalItemTableEdit();
    this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
  }

  deleteRowOnAbnormalItemTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Confirm.Delete'),
      icon: 'pi pi-info-circle',
      accept: () => {
        if (this.checkedRowOfAbnormalItemTable.length > 0) {
          this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
          this.removeRemoveFromAbnormalItemTable();

          if (this.dataOfAbnormalItemTable.length <= 0) {
            this.headerCheckboxOfAbnormalItemTable.writeValue(false);
          }

          this.checkedRowOfAbnormalItemTable = [];
          this.toastService.success(this.translateService.instant("AdvisingAbnormal.Table.AbnormalItem.Toast.Success.DeleteSuccess"));
        }
      }
    })
  }

  saveDataChangesOnAbnormalItemTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        if (!this.isUserInputValidOnAbnormalItemTable(this.selectedRowOfAbnormalItemTable)) {
          return;
        }

        this.isAbnormalItemTableLoading = true;
        this.checkAbnormalItemTableChanges();
        const request: AdvisingAbnormalTableAbnormalItemSaveRequest = this.createAbnormalItemSaveRequest()

        this.advisingAbnormalService.saveAbnormalItemChanges(request).subscribe({
          next: () => {
            this.getDetailTableData();
            this.getAbnormalItemTableData();
            this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Success.SaveSuccess'));
          },
          error: (response: { status: number; }) => {
            this.toastService.error(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Failure.SaveFail') + response.status);
          },
          complete: () => {
            this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
            this.isAbnormalItemTableInEditMode = false;
            this.isAbnormalItemTableLoading = false;
            this.newAbnormalItemList = [];
            this.updatedAbnormalItemList = [];
          }
        });
      }
    })
  }

  restoreDataOnAbnormalItemTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreAbnormalItem();
        this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
        this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Success.RestoreSuccess'))
      }
    })
  }

  switchEditModeOnAbnormalItemTable() {
    if (this.isAbnormalItemTableInEditMode) {
      this.confirmationService.confirm({
        header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
        message: this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isAbnormalItemTableInEditMode = false;
          this.restoreAbnormalItem();
          this.toastService.success(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Success.EditingCancelSuccess'))
        }
      })
    }
    else {
      this.isAbnormalItemTableInEditMode = true;
      if (!isNullOrEmpty(this.selectedRowOfAbnormalItemTable)) {
        this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
      }
    }
  }

  toggleAllRowCheckboxOnAbnormalItemTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfAbnormalItemTable.writeValue(!this.headerCheckboxOfAbnormalItemTable.checked())
    }

    this.rowCheckboxesOfAbnormalItemTable.toArray().forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfAbnormalItemTable.checked());
    })

    this.checkedRowOfAbnormalItemTable = this.headerCheckboxOfAbnormalItemTable.checked() ? deepCopy(this.dataOfAbnormalItemTable) ?? [] : [];

  }

  toggleRowCheckboxOnAbnormalItemTable(event: any, rowData: AdvisingAbnormalTableAbnormalItemData) {
    if (event.checked) {
      this.checkedRowOfAbnormalItemTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfAbnormalItemTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfAbnormalItemTable.splice(removedIndex, 1);
    }
  }

  reselectAfterEnterKeyDown(event: { originalEvent?: Event, data?: AdvisingAbnormalTableAbnormalItemData }) {
    if(event.originalEvent instanceof KeyboardEvent
      && event.originalEvent?.key == 'Enter'
      && event.data
    ) {
      this.selectedRowOfAbnormalItemTable = event.data
      this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable);
    }
  }

  selectRowOnAbnormalItemTable(rowData: AdvisingAbnormalTableAbnormalItemData) {
    // Keep the selectedRow variable is pointing at the user's selected row
    // Whether is select or deselect
    this.selectedRowOfAbnormalItemTable = rowData;

    if (this.isReselectAbnormalItemTableRow()) {
      this.updateAbnormalItemTableHighlight(this.previousSelectedRowOfAbnormalItemTable);
      return;
    }

    if (this.isAbnormalItemTableInEditMode) {
      if (!this.isUserInputValidOnAbnormalItemTable(this.previousSelectedRowOfAbnormalItemTable)) {
        // Rollback the selected row to the row which doesn't fill the required data well
        this.selectedRowOfAbnormalItemTable = this.previousSelectedRowOfAbnormalItemTable;
        this.updateAbnormalItemTableHighlight(this.previousSelectedRowOfAbnormalItemTable);
        return;
      }
      // Change the current selected row to the user's selected row
      this.abnormalItemTable.cancelRowEdit(this.previousSelectedRowOfAbnormalItemTable);
      this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
    }
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
  }

  pagingOnAbnormalItemTable(event: { first: number, rows: number }) {
    this.pageInfoOfAbnormalItemTable.pageSize = event.rows;
    this.pageInfoOfAbnormalItemTable.pageIndex = event.first / event.rows;
    this.getAbnormalItemTableData();

  }

  sortingOnAbnormalItemTable(event: { field: string, order: number }) {
    if (this.dataOfAbnormalItemTable.length > 0) {
      this.sortInfoOfAbnormalItemTable = { property: event.field, direction: event.order };
      this.getAbnormalItemTableData();
    }
  }

  showAbnormalItemFiles(event: Event, rowData: AdvisingAbnormalTableAbnormalItemData) {
    this.stopBubblingPhases(event);

    this.selectRowOnAbnormalItemTable(rowData)
    if (this.selectedRowOfAbnormalItemTable!.dataKey != rowData.dataKey) {
      return;
    }

    this.fileDocIdOfCurrentAbnormalItem = deepCopy(this.selectedRowOfAbnormalItemTable?.docIds) ?? [];
    this.isShowAbnormalItemFileDialog = true;
    this.keepDialogToFullScreenInMobileMode(this.abnormalItemFileDialog);
    this.getAbnormalItemFile();
  }

  async setAbnormalItemPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfoOfAbnormalItemTable.pageSize = event.rows;
  }

  private isUserInputValidOnAbnormalItemTable(rowData: AdvisingAbnormalTableAbnormalItemData | null): boolean {
    if (rowData) {
      if (
        isNullOrEmpty(rowData.waitingReference)
      ) {
        this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Warning.EmptyData'));
        return false;
      }

      if (
        rowData.abnormalCaseCnt != null && rowData.abnormalCaseCnt < 0
      ) {
        this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Table.AbnormalItem.Toast.Warning.NegativeAbnormalCaseCnt'));
        return false;
      }
    }
    return true;
  }

  private removeRemoveFromAbnormalItemTable() {
    for (let rowOfRemove of this.checkedRowOfAbnormalItemTable) {
      const indexOfRow = this.dataOfAbnormalItemTable.findIndex(data => data.dataKey == rowOfRemove.dataKey);
      if (indexOfRow > - 1) {
        this.dataOfAbnormalItemTable.splice(indexOfRow, 1);
        this.addDeletedListOfAbnormalItemTable(rowOfRemove.seqNo);
      }
    }
    this.changeSelectedRowToFirstRowOnAbnormalItemtable();
  }

  private addDeletedListOfAbnormalItemTable(deletedSeqNo: number | null) {
    if (deletedSeqNo != null) {
      this.deletedSeqNoGroupOfAbnormalItemTable.push(deletedSeqNo)
    }
  }

  private changeSelectedRowToFirstRowOnAbnormalItemtable() {
    this.selectedRowOfAbnormalItemTable = this.dataOfAbnormalItemTable[0];
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
    this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
    this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable);
  }

  private checkAbnormalItemTableChanges() {
    let changedDataIndex = 0;

    // Check if any data inside Abnormal Item table
    if (changedDataIndex < this.dataOfAbnormalItemTable.length) {

      for (const abnormalItemData of this.dataOfAbnormalItemTable) {
        // Check if any added row by dataKey property
        // Added row's dataKey format : --id
        if (abnormalItemData.dataKey[0] != '-') {
          break;
        }
        this.recordNewAbnormalItem(abnormalItemData);
        changedDataIndex++;
      }

      // Reverse for maintain order of user adding new row
      this.newAbnormalItemList.reverse();

      // Compare backup table data to current table data
      for (const backupAbnormalItemData of this.backupDataOfAbnormalItemTable) {
        if (this.deletedSeqNoGroupOfAbnormalItemTable.indexOf(backupAbnormalItemData.seqNo) == -1) {
          if (JSON.stringify(this.dataOfAbnormalItemTable[changedDataIndex]) != JSON.stringify(backupAbnormalItemData)) {
            this.recordUpdatedAbnormalItem(this.dataOfAbnormalItemTable[changedDataIndex]);
          }
          changedDataIndex++;
        }
      }
    }
  }

  private recordNewAbnormalItem(newAbnormalItem: AdvisingAbnormalTableAbnormalItemData) {
    this.newAbnormalItemList.push(newAbnormalItem);
  }

  private recordUpdatedAbnormalItem(updatedAbnormalItem: AdvisingAbnormalTableAbnormalItemData) {
    this.updatedAbnormalItemList.push(updatedAbnormalItem);
  }

  // Check if user reselect selected Abnormal Item row
  private isReselectAbnormalItemTableRow(): boolean {
    return this.previousSelectedRowOfAbnormalItemTable != null
      && this.previousSelectedRowOfAbnormalItemTable.dataKey === this.selectedRowOfAbnormalItemTable!.dataKey
  }

  private keepDialogToFullScreenInMobileMode(dialog: Dialog) {
    if (!this.isInDesktopMode()) {
      dialog.maximizable = false;
      dialog.maximized = false;
      dialog.maximize();
      dialog.disableModality();
    }
  }

  // Cancel current AbnormalItem table's row editing
  private clearAbnormalItemTableEdit() {
    this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
    this.selectedRowOfAbnormalItemTable = this.dataOfAbnormalItemTable[0];
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;

    //Avoid the highlighted part leave on the previous row
    this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable);
  }

  private restoreAbnormalItem() {
    this.restoreAbnormalItemTable();
    this.restoreAbnormalItemInternalData();
  }

  private restoreAbnormalItemTable() {
    this.dataOfAbnormalItemTable = deepCopy(this.backupDataOfAbnormalItemTable)!;
    this.clearAbnormalItemTableEdit();
  }

  private restoreAbnormalItemInternalData(): void {
    // Clear user changed action
    this.checkedRowOfAbnormalItemTable = [];
    this.headerCheckboxOfAbnormalItemTable.writeValue(false);

    this.newAbnormalItemDataKeyId = 0;
    this.newAbnormalItemList = [];
    this.updatedAbnormalItemList = [];
    this.deletedSeqNoGroupOfAbnormalItemTable = [];

    if (!this.isInDesktopMode) {
      this.abnormalItemTable.resetScrollTop();
    }
  }

  private createAbnormalItemSaveRequest(): AdvisingAbnormalTableAbnormalItemSaveRequest {
    let request = new AdvisingAbnormalTableAbnormalItemSaveRequest();
    request.userName = this.userService.userInfo.userName;
    request.operationDate = new Date();
    request.newAdvsingAbnormalItems = this.newAbnormalItemList;
    request.updatedAdvisingAbnormalItems = this.updatedAbnormalItemList;
    request.deletedAdvisingAbnormalItemSeqNos = this.deletedSeqNoGroupOfAbnormalItemTable;
    return request;
  }

  // Control the selection highlighting back to the row
  private updateAbnormalItemTableHighlight(selectedRow: AdvisingAbnormalTableAbnormalItemData | null): void {
    if (!selectedRow) {
      return;
    }
    this.abnormalItemTable.selection = selectedRow;
    this.abnormalItemTable.selectionKeys = {};
    this.abnormalItemTable.selectionKeys[selectedRow.dataKey] = 1;
    this.abnormalItemTable.tableService.onSelectionChange();
  }

  //#endregion Abnormal Item Table Function

  //#region New Abnormal Item Dialog Function

  visibleChangeOfNewAbnormalItemDialog(visible: boolean) {
    if (!visible) {
      this.confirmationService.confirm({
        header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
        message: this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.clearDialog();
        },
        reject: () => {
          this.isShowNewAbnormalItemDialog = true;
        }
      })

    }
  }

  clearDialog() {
    this.newAbnormalItemDialogFormGroup.reset();
    this.dataOfFileTable = [];
    this.fileTable.first = 0;
    this.restoreRelatedDetailTableInternalData();
  }

  //#region File Table Function

  removeChosenFile(rowIndex: number) {
    this.dataOfFileTable.splice(rowIndex, 1);
    this.fileTable.totalRecords = this.dataOfFileTable.length
  }

  onNewFileSelect(fileInput: HTMLInputElement) {
    let files = fileInput.files;
    if(!files){
      fileInput.value = "";
      return;
    }

    const MAX_SIZE_MB = 50 * 1024 * 1024;
    let fileDatas: File[] = [];
    let totalFileSize = this.dataOfFileTable.reduce((total, file)=> total + file.size, 0);
    let newFileSize = Array.from(files).reduce((total, file) => total + file.size, 0);

    if(totalFileSize + newFileSize > MAX_SIZE_MB){
      this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Warning.FileSizeLimit'))
    }else{
      Array.prototype.forEach.call(files, file => {
        if (!this.isFileSelectedInFileTable(file)) {
          fileDatas.push(file);
        }

      });

      this.dataOfFileTable = this.dataOfFileTable.concat(fileDatas)
    }

    fileInput.value = "";
  }

  private isFileSelectedInFileTable(file: File): boolean {
    for (let fileData of this.dataOfFileTable) {
      if ((fileData.name + fileData.type + fileData.size) === (file.name + file.type + file.size)) {
        return true;
      }
    }
    return false;
  }

  //#endregion File Table Function

  //#region Related Detail Table Function

  toggleAllRowCheckboxOnRelatedDetailTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfRelatedDetailTable.writeValue(!this.headerCheckboxOfRelatedDetailTable.checked())
    }

    this.rowCheckboxesOfRelatedDetailTable.toArray().forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfRelatedDetailTable.checked());
    })

    this.checkedRowOfRelatedDetailTable = this.headerCheckboxOfRelatedDetailTable.checked() ? deepCopy(this.dataOfRelatedDetailTable) ?? [] : [];

  }

  toggleRowCheckboxOnRelatedDetailTable(event: { checked?: any }, rowData: AdvisingAbnormalTableDetailData) {
    if (event.checked) {
      this.checkedRowOfRelatedDetailTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfRelatedDetailTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfRelatedDetailTable.splice(removedIndex, 1);
    }
  }

  private restoreRelatedDetailTableInternalData() {
    this.checkedRowOfRelatedDetailTable = [];
    this.headerCheckboxOfRelatedDetailTable.writeValue(false);
  }

  //#endregion Related Detail Table Function

  createNewAbnormalItem() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Confirm.Upload'),
      icon: 'pi pi-info-circle',
      accept: async () => {
        if (!this.isAbleToCreateNewAbnormalItem()) {
          return;
        }

        this.isNewAbnormalItemDialogLoading = true;
        let createAbnormalItemRequest = await this.createRequestForCreateAbnormalItem();
        this.advisingAbnormalService.createAdvisingAbnormalItem(createAbnormalItemRequest).subscribe({
          next: () => {
            this.clearDialog();
            this.isNewAbnormalItemDialogLoading = false;
            this.isShowNewAbnormalItemDialog = false;

            this.restoreDetailInternalData();
            this.toggleAllRowCheckboxOnDetailTable();
            this.getDetailTableData();
            this.getAbnormalItemTableData();
            this.toastService.success(this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Success.UploadSuccess'))
          },
          error: (response) => {
            if (response.error != null && response.error.category == this.ERROR_CODE_CATEGORY) {
              this.toastErrorMessage(response.error)
            }
            else {
              this.toastService.error(this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Failure.UploadFailure') + response.status);
            }
          }
        })
      }
    });
  }

  private isAbleToCreateNewAbnormalItem(): boolean {
    if (
      isNullOrEmpty(this.newAbnormalItemDialogFormGroup.value.waitingReference)
    ) {
      this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Warning.EmptyData'));
      return false;
    }

    if (
      this.newAbnormalItemDialogFormGroup.value.abnormalCaseCnt != null
      && this.newAbnormalItemDialogFormGroup.value.abnormalCaseCnt < 0
    ) {
      this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Warning.NegativeAbnormalCaseCnt'));
      return false;
    }
    return true;
  }

  private async createRequestForCreateAbnormalItem(): Promise<AdvisingAbnormalCreateAbnormalItemRequest> {
    let createAbnormalItemRequest = new AdvisingAbnormalCreateAbnormalItemRequest()
    createAbnormalItemRequest.userName = this.userService.userInfo.userName;
    createAbnormalItemRequest.operationDate = new Date();
    createAbnormalItemRequest.adNo = this.selectedRowOfHeaderTable?.adNo ?? "";
    createAbnormalItemRequest.newFiles = await this.convertToFileBase64Beans(this.dataOfFileTable);
    createAbnormalItemRequest.abnormalCaseCnt = this.newAbnormalItemDialogFormGroup.value.abnormalCaseCnt;
    createAbnormalItemRequest.waitingReference = this.newAbnormalItemDialogFormGroup.value.waitingReference;
    createAbnormalItemRequest.waitingReferenceDesc = this.newAbnormalItemDialogFormGroup.value.waitingReferenceDesc;
    createAbnormalItemRequest.relatedDetailSeqNos = this.checkedRowOfRelatedDetailTable.map(rowData => rowData.seqNo);
    createAbnormalItemRequest.relatedDetailExternLineNos = this.checkedRowOfRelatedDetailTable.map(rowData => rowData.externLineNo);
    createAbnormalItemRequest.relatedDetailSkus = this.checkedRowOfRelatedDetailTable.map(rowData => rowData.sku);
    return createAbnormalItemRequest;
  }

  private async convertToFileBase64Beans(files: File[]): Promise<AdvisingAbnormalItemFileBase64Bean[] | null> {
    if (files && files.length > 0) {
      let fileBase64Beans: AdvisingAbnormalItemFileBase64Bean[] = [];
      for (let file of files) {
        let fileBase64: string | null = await this.convertFileToBase64(file);
        if (fileBase64 != null) {
          let fileBase64Bean = this.convertToFileBase64Bean(file, fileBase64);
          fileBase64Beans.push(fileBase64Bean);
        }
      }
      return fileBase64Beans;
    }
    return null;
  }

  private convertToFileBase64Bean(file: File, fileBase64: string): AdvisingAbnormalItemFileBase64Bean {
    let fileNameArray = file.name.split('.');
    let fileExtension: string | null = fileNameArray.pop()!;
    let fileName = fileNameArray.join('.')!;

    if (fileName.length == 0) {
      fileName = fileExtension;
      fileExtension = null;
    }

    let fileBase64Bean = new AdvisingAbnormalItemFileBase64Bean();
    fileBase64Bean.fileName = fileName;
    fileBase64Bean.fileExtension = fileExtension;
    fileBase64Bean.fileType = file.type;
    fileBase64Bean.fileBase64s = fileBase64;
    return fileBase64Bean;
  }

  //#endregion Dialog Function

  //#region Abnormal Item File Dialog Function

  visibleChangeOfAbnormalItemFileDialog(visible: boolean) {
    if (!visible) {
      this.confirmationService.confirm({
        header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
        message: this.translateService.instant('AdvisingAbnormal.Dialog.AbnormalItemFile.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.onCloseAbnormalItemFileDialog();
        },
        reject: () => {
          this.isShowAbnormalItemFileDialog = true;
        }
      })
    }
  }

  transformToSafeUrl(url: string | null) {
    return url ? this.sanitizer.bypassSecurityTrustUrl(url) : '';
  }

  onFileClick(index: number) {
    if (this.isInDesktopMode()) {
      // Because Galleria follow the dialog's size
      // Below make galleria in full screen
      // but when close the galleria, restore the dialog to its original size
      let originalMaximized = this.abnormalItemFileDialog.maximized;
      this.abnormalItemFileDialog.maximized = false;
      this.abnormalItemFileDialog.maximize();
      this.abnormalItemFileDialog.disableModality();
      this.abnormalItemFileDialog.maximized = !originalMaximized;
    }

    this.isShowBigFile = true;
    this.indexOfGalleria = index;
  }

  visibleChangeOfGalleria() {
    if (this.isInDesktopMode()) {
      // Restore the dialog to its original size
      this.abnormalItemFileDialog.maximize();
      this.abnormalItemFileDialog.disableModality();
    }
  }

  async addFileToAbnormalItem(fileInput: HTMLInputElement) {
    let files = fileInput.files;
    if (!files || this.isExceedMaxSize(files)) {
      fileInput.value = "";
      return;
    }

      for (let i = 0; i < files.length; i++) {
        if (!this.isFileSelectedInAbnormalItemFile(files[i])) {
          let fileBase64 = await this.convertFileToBase64(files[i]);
          if (fileBase64) {
            let abnormalItemFile = this.convertToAbnormalItemFile(files[i], fileBase64);
            this.fileOfAbnormalItemFileDialog.splice(i, 0, abnormalItemFile);
            this.fileDocIdOfCurrentAbnormalItem.splice(i, 0, '');

            let abnormalItemFileBase64 = this.convertToFileBase64Bean(files[i], fileBase64);
            this.newAbnormalItemFileBase64s.push(abnormalItemFileBase64);
          }
        }
      }

    fileInput.value = "";
  }

  isExceedMaxSize(files: FileList): boolean{
    const MAX_SIZE_MB = 50 * 1024 * 1024;
    let totalFileSize = this.fileOfAbnormalItemFileDialog.reduce((total, file) => total + this.base64Size(file.fileDataUrl!), 0);
    let newFileSize = Array.from(files).reduce((total, file) => total + file.size, 0);

    if(totalFileSize + newFileSize > MAX_SIZE_MB){
      this.toastService.warn(this.translateService.instant('AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Warning.FileSizeLimit'))
      return true;
    }

    return false;
  }

  base64Size(base64: string): number {
    let padding = 0;
    if (base64.endsWith('==')) {
      padding = 2;
    } else if (base64.endsWith('=')) {
      padding = 1;
    }
    const base64Length = base64.length - padding;
    return (base64Length * 3) / 4;
  }

  deleteFileFromAbnormalItem(index: number) {
    let deletedDocId: string = this.fileDocIdOfCurrentAbnormalItem[index];
    this.fileDocIdOfCurrentAbnormalItem.splice(index, 1);
    this.fileOfAbnormalItemFileDialog.splice(index, 1);
    if (deletedDocId != '') {
      this.deletedAbnormalItemFileDocIds.push(deletedDocId);
    }
  }

  restoreAbnormalItemFileData() {
    this.fileDocIdOfCurrentAbnormalItem = deepCopy(this.selectedRowOfAbnormalItemTable?.docIds) ?? [];
    this.fileOfAbnormalItemFileDialog = deepCopy(this.backupFileOfAbnormalItemFileDialog) ?? [];
    this.clearUserOperationOnAbnormalFileDialog();
  }

  onSaveBtnClickOnAbnormalItemFileDialog() {
    this.confirmationService.confirm({
      header: this.translateService.instant('AdvisingAbnormal.Confirm.Header'),
      message: this.translateService.instant('AdvisingAbnormal.Dialog.AbnormalItemFile.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saveDataChangesOnAbnormalFileDialog();
      }
    })
  }

  isImageTypeFile(fileType: string): boolean {
    return this.getTypeClass(fileType) === this.getTypeClass("image/*")
  }

  isAbleToSaveAbnormalItemFileChange() {
    return (this.newAbnormalItemFileBase64s != null && this.newAbnormalItemFileBase64s.length > 0)
      || (this.deletedAbnormalItemFileDocIds != null && this.deletedAbnormalItemFileDocIds.length > 0)
  }

  isAbnormalItemFileDialogInEditMode(): boolean {
    return this.abnormalItemFileDialogMode === this.ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Edit;
  }

  private getAbnormalItemFile() {
    this.isAbnormalItemFileDialogLoading = true;
    let fileRequest: AdvisingAbnormalItemFilesRequest = this.createfileGetRequest();
    this.getFileSubscribe = this.advisingAbnormalService.findFilesBySnGroup(fileRequest).subscribe({
      next: (response: any) => {
        if (response.files) {
          this.fileOfAbnormalItemFileDialog = [];
          this.setAbnormalItemFileDialogDataBy(response);
          this.backupFileOfAbnormalItemFileDialog = deepCopy(this.fileOfAbnormalItemFileDialog) ?? []
        }
      },
      complete: () => {
        this.isAbnormalItemFileDialogLoading = false;
      }
    })
  }

  private createfileGetRequest(): AdvisingAbnormalItemFilesRequest{
    let fileRequest: AdvisingAbnormalItemFilesRequest = new AdvisingAbnormalItemFilesRequest();
    fileRequest.docIds = this.fileDocIdOfCurrentAbnormalItem;
    fileRequest.userName = this.userService.userInfo.userName;
    return fileRequest;

  }

  private setAbnormalItemFileDialogDataBy(response: AdvisingAbnormalItemFileResponse) {
    if (response.files) {
      for (let responseFile of response.files) {
        let abnormalItemDialogFile = new AdvisingAbnormalDialogItemFile();
        abnormalItemDialogFile.fileName = responseFile.fileName;
        abnormalItemDialogFile.fileExtension = responseFile.fileExtension;
        abnormalItemDialogFile.fileType = responseFile.fileType;
        abnormalItemDialogFile.fileDataUrl = `data:${responseFile.fileType};base64,${responseFile.fileContent}`;
        this.filePermission = responseFile.filePermission;
        this.fileOfAbnormalItemFileDialog.push(abnormalItemDialogFile);
      }
    }
  }

  private isFileSelectedInAbnormalItemFile(file: File): boolean {
    for (let abnormalItemFile of this.fileOfAbnormalItemFileDialog) {
      let fileName = file.name.split('.')
      if ((abnormalItemFile.fileName! + abnormalItemFile.fileType) === (fileName[0] + fileName[1] + file.type)) {
        return true;
      }
    }
    return false;
  }

  private convertToAbnormalItemFile(file: File, fileBase64: string) {
    let fileNameArray = file.name.split('.');
    let fileExtension: string | null = fileNameArray.pop()!;
    let fileName = fileNameArray.join('.')!;

    if (fileName.length == 0) {
      fileName = fileExtension;
      fileExtension = null;
    }

    let abnormalItemFile = new AdvisingAbnormalDialogItemFile();
    abnormalItemFile.fileName = fileName;
    abnormalItemFile.fileExtension = fileExtension;
    abnormalItemFile.fileType = file.type;
    abnormalItemFile.fileDataUrl = `data:${file.type};base64,${fileBase64}`;
    return abnormalItemFile;
  }

  private onCloseAbnormalItemFileDialog() {
    this.getFileSubscribe?.unsubscribe();
    this.fileOfAbnormalItemFileDialog = [];
    this.backupFileOfAbnormalItemFileDialog = [];
    this.fileDocIdOfCurrentAbnormalItem = [];
    this.abnormalItemFileDialogMode = this.ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Edit;
    this.clearUserOperationOnAbnormalFileDialog();
  }

  private async convertFileToBase64(file: File): Promise<string | null> {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let result = fileReader.result as string;
        if (result) {
          resolve(result.split(',')[1]);
        }
      }
      fileReader.onerror = () => reject(null)
    })
  }

  private saveDataChangesOnAbnormalFileDialog() {
    this.isAbnormalItemFileDialogLoading = true;

    let updateRequest: AdvisingAbnormalDialogAbnormalItemFileUpdateRequest = this.createAbnormalItemFileUpdateRequest();
    this.advisingAbnormalService.updateAbnormalItemFiles(updateRequest).subscribe({
      next: (response) => {
        if (response.newFileDocIds) {
          let newFileDocIds = response.newFileDocIds;
          for (let i = 0; i < newFileDocIds.length; i++) {
            this.fileDocIdOfCurrentAbnormalItem[i] = newFileDocIds[i];
          }
          this.updateDataDocIdOfAbnormalItemTable();
        }
        this.toastService.success(this.translateService.instant('AdvisingAbnormal.Dialog.AbnormalItemFile.Toast.Success.SaveSuccess'));
      },
      error: (response) => {
        this.isAbnormalItemFileDialogLoading = false;
        this.toastService.error(this.translateService.instant('AdvisingAbnormal.Dialog.AbnormalItemFile.Toast.Failure.SaveFailure') + response.status);
      },
      complete: () => {
        this.isAbnormalItemFileDialogLoading = false;
        this.clearUserOperationOnAbnormalFileDialog();
      }
    })
  }

  private createAbnormalItemFileUpdateRequest(): AdvisingAbnormalDialogAbnormalItemFileUpdateRequest {
    let abnormalItemFileUpdateRequest: AdvisingAbnormalDialogAbnormalItemFileUpdateRequest = new AdvisingAbnormalDialogAbnormalItemFileUpdateRequest();
    abnormalItemFileUpdateRequest.userName = this.userService.userInfo.userName;
    abnormalItemFileUpdateRequest.operationDate = new Date();
    abnormalItemFileUpdateRequest.abnormalItemSeqNo = this.selectedRowOfAbnormalItemTable?.seqNo ?? -1;
    abnormalItemFileUpdateRequest.newFiles = this.newAbnormalItemFileBase64s;
    abnormalItemFileUpdateRequest.deletedAbnormalItemFileDocIds = this.deletedAbnormalItemFileDocIds;
    return abnormalItemFileUpdateRequest;
  }

  private updateDataDocIdOfAbnormalItemTable() {
    this.selectedRowOfAbnormalItemTable!.docIds = deepCopy(this.fileDocIdOfCurrentAbnormalItem) ?? [];
    const backupDataIndex = this.backupDataOfAbnormalItemTable.findIndex(data =>
      data.dataKey == this.selectedRowOfAbnormalItemTable?.dataKey);
    this.backupDataOfAbnormalItemTable[backupDataIndex].docIds = deepCopy(this.selectedRowOfAbnormalItemTable!.docIds) ?? [];
  }

  private clearUserOperationOnAbnormalFileDialog() {
    this.newAbnormalItemFileBase64s = [];
    this.deletedAbnormalItemFileDocIds = [];
  }

  private getTypeClass(fileType: string): string {
    return fileType.substring(0, fileType.indexOf('/'));
  }
}
